<app-navbar
  (signOutEmitter)="signOut()"
  (loadedEmitter)="onLoaded()"
  [email]="email"
  [user]="user"
  [isAuthenticated]="isAuthenticated"
>
</app-navbar>

<app-dc-loading *ngIf="loading && isAuthenticated"> Initializing... </app-dc-loading>
<router-outlet *ngIf="!loading || !isAuthenticated"></router-outlet>
<div class="app-version">
  <div class="environment">
    {{ environment }}
  </div>
  Build Number: {{ appBuildNumber }}<br />
  Build Date: {{ appBuildDateString }}<br />
  Version: {{ appVersion.substring(0, 10) }}<br />
</div>
